<div
  #element
  (click)='menuClicked($event)'
  *ngIf='menuItems && menuItems.length > 0'
  [class.shrink]='shouldShrink()'
  class='LeftMenu container'>
  <div class='LeftMenu-image pt-3'>
    <a href='/'>
      <img
        alt='Retreva Logo'
        height='85'
        src='assets/images/Group-3789.svg' />
    </a>
  </div>
  <!--    no mockup-->
  <app-total-count
    [showInboxStatus]='shouldShowActiveStatus()'></app-total-count>
  <ul class='LeftMenu-menu'>
    <ng-container *ngFor='let item of menuItems'>
      <li class='LeftMenu-menu-item'>
        <a
          *ngIf="item.route.indexOf('http') === -1"
          [class.activated]='expanded === item.class || item.activeRoute'
          [routerLink]='item.route'
          class="LeftMenu-menu-item-container {{
            item.class ? item.class : ''
          }}">
          <div class='LeftMenu-menu-item-badge'></div>
          <div class='LeftMenu-menu-item-icon'>
            <app-svg-renderer
              *ngIf='item.icon && !item.faIcon'
              [ngClass]="
                expanded === item.class || item.activeRoute
                  ? ['menu-icon', 'menu-icon-active']
                  : ['menu-icon']
              "
              [svg]='item.icon'></app-svg-renderer>
            <fa-icon *ngIf='!item.icon && item.faIcon' [icon]='item.faIcon' [ngClass]='getFaIconClass(item)'
                     size='2x'></fa-icon>
          </div>
          <div class='LeftMenu-menu-item-label'>
            {{ item.label }}
          </div>
        </a>
        <a
          *ngIf="item.route.indexOf('http') > -1"
          [class.activated]='expanded === item.class || item.activeRoute'
          [href]='item.route'
          class="LeftMenu-menu-item-container {{
            item.class ? item.class : ''
          }}"
          target='_blank'>
          <div class='LeftMenu-menu-item-badge'></div>
          <div class='LeftMenu-menu-item-icon'>
            <app-svg-renderer
              *ngIf='item.icon && !item.faIcon'
              [ngClass]="
                expanded === item.class || item.activeRoute
                  ? ['menu-icon', 'menu-icon-active']
                  : ['menu-icon']
              "
              [svg]='item.icon'></app-svg-renderer>
            <fa-icon *ngIf='!item.icon && item.faIcon' [icon]='item.faIcon' [ngClass]='getFaIconClass(item)'
                     size='2x'></fa-icon>
          </div>
          <div class='LeftMenu-menu-item-label'>
            {{ item.label }}
          </div>
        </a>
      </li>
      <ng-container *ngFor='let subItem of item.children'>
        <li
          *ngIf='item.class && expanded === item.class'
          [class.activated]='subItem.activeRoute'
          class='LeftMenu-menu-item sub'>
          <app-svg-renderer
            (click)='onIconClick($event, subItem)'
            *ngIf='subItem.icon' [svg]='subItem.icon'></app-svg-renderer>
          <a *ngIf='!subItem.link' [routerLink]='subItem.route'>{{
              subItem.label
            }}</a>
          <a *ngIf='subItem.link' href='{{ subItem.link }}'>{{
              subItem.label
            }}</a>
          <ng-container *ngIf='subItem.hasExtra; else extraView'>
            <ng-container *ngIf='subItem.extra !== undefined; else spinner'>
              <ng-container *ngTemplateOutlet='extraView; context:{item: subItem}'></ng-container>
            </ng-container>
            <ng-template #spinner>
              <mat-spinner [diameter]='25'></mat-spinner>
            </ng-template>
          </ng-container>
          <ng-template #extraView let-item='item'>
            <span *ngIf='item' class='pull-right me-3 LeftMenu-menu-item-counter'>
              {{ item.extra }}
            </span>
          </ng-template>
        </li>
      </ng-container>
    </ng-container>
  </ul>
</div>
